import React, { ReactElement } from "react";
import { createRoot } from "react-dom/client";

const container = document.getElementById("app");
const root = createRoot(container as Element);

export const RenderApp = (app: ReactElement): void => {
	root.render(<>{app}</>);
};
